<div class="flex flex-col gap-3">
  <p class="text-text-secondary">{{ 'devices.detailTabs.feeds.description' | translate }}</p>
  <xemex-table
    [data]="rows()"
    [columns]="columns"
    [loading]="loading()"
    [pageable]="false"
    [rowLink]="rowLink"
  ></xemex-table>
  @if (hiddenCount() > 0) {
    <p class="text-text-secondary">
      {{ 'devices.detailTabs.feeds.hidden' | translate: { count: hiddenCount() } }}
    </p>
  }
</div>
